import type { ResponseDto } from '@app/api/dtos'
import type { ContractorsDto } from '@app/api/routes/contractors/dtos'
import type { TableData } from '@app/types/table'
import type { ContractorsDataSource } from '../types'

export const adaptContractorsTableData = (
  contractorsResponse: ResponseDto<ContractorsDto>
): TableData<ContractorsDataSource> => {
  const { count, results: contractors } = contractorsResponse

  const dataSource: ContractorsDataSource[] = contractors.map(dto => ({
    key: dto.id,
    code: dto.id,
    name: dto.name,
    // TODO: будет ли login - узнать у бэка, сейчас такого ключа нет
    login: 'MOCK LOGIN',
    email: dto.email,
    additionalInfo: dto.additionalInfo,
    contacts: dto.contacts
  }))

  return { count, dataSource }
}
